<div class="our-apps-row pb-80">
    <div class="container">
        <!-- <div class="text-center ps-5 pe-5">  
            <h2 class="mb-3">Our Apps</h2>
        </div> -->

        <div class="row ms-lg-5 mt-5">
            <div class="offset-lg-1 col-lg-3 col-md-4">
                <div class="card text-center" routerLink="/container-specification">
                    <img src="../assets/images/icons/container-specification.png" class="card-img-top img-fluid app-img pt-0" alt="Container Specification">
                    <div class="card-body">
                      <h5 class="card-title">Container Specification</h5>
                      <p class="card-text">Display specifications for a variety of container types</p>
                      <a class="btn btn-primary btn-details" routerLink="/container-specification">Details</a>
                    </div>
                  </div>
            </div>

            <div class="col-lg-3 col-md-4">
                <div class="card text-center" routerLink="/emission-calculator">
                    <img src="../assets/images/icons/emission-calculator.png" class="card-img-top img-fluid app-img" alt="Emission Calculator">
                    <div class="card-body">
                      <h5 class="card-title">Emission Calculator</h5>
                      <p class="card-text">Apply industry recognized methods of calculation to different sections of the transport chain</p>
                      <a class="btn btn-primary btn-details" routerLink="/emission-calculator">Details</a>
                    </div>
                  </div>
            </div>

            <div class="col-lg-3 col-md-4">
                <div class="card text-center" routerLink="/freight-volume-calculator">
                    <img src="../assets/images/icons/freight-volume-calculator.png" class="card-img-top img-fluid app-img" alt="Freight Volume Calculator">
                    <div class="card-body">
                      <h5 class="card-title">Freight Volume Calculator</h5>
                      <p class="card-text">Calculate volume and volumetric weight for your cargo</p>
                      <a class="btn btn-primary btn-details" routerLink="/freight-volume-calculator">Details</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row ms-lg-5 mt-30 res-mt-0">
            <div class="offset-lg-1 col-lg-3 col-md-4">
                <div class="card text-center" routerLink="/container-vessel-tracker">
                    <img src="../assets/images/icons/container-vessel-tracker.png" class="card-img-top img-fluid app-img" alt="Container Vessel Tracker">
                    <div class="card-body">
                      <h5 class="card-title">Container Vessel Tracker</h5>
                      <p class="card-text">Quickly display basic shipping data related to tracking</p>
                      <a class="btn btn-primary btn-details" routerLink="/container-vessel-tracker">Details</a>
                    </div>
                  </div>
            </div>

            <div class="col-lg-3 col-md-4">
                <div class="card text-center" routerLink="/inco-terms">
                    <img src="../assets/images/icons/inco-terms.png" class="card-img-top img-fluid app-img" alt="Inco Terms">
                    <div class="card-body">
                      <h5 class="card-title">INCO Terms</h5>
                      <p class="card-text">INCO Terms rules or International Commercial terms</p>
                      <a class="btn btn-primary btn-details" routerLink="/inco-terms">Details</a>
                    </div>
                  </div>
            </div>

            <div class="col-lg-3 col-md-4">
                <div class="card text-center" routerLink="/shipping-glossary">
                    <img src="../assets/images/icons/shipping-glossary.png" class="card-img-top img-fluid app-img" alt="Shipping Glossary">
                    <div class="card-body">
                      <h5 class="card-title">Shipping Glossary</h5>
                      <p class="card-text">Familiarize yourself with a glossary of shipping terms and look up abbreviations</p>
                      <a class="btn btn-primary btn-details" routerLink="/shipping-glossary">Details</a>
                    </div>
                  </div>
            </div>
        </div>
    </div>
</div>
